import React from 'react';
import PropTypes from 'prop-types';

// Components
import Search from '../Search';
import SearchResults from '../Search/SearchResults';
import SearchRefinementsMembersMyMatches from '../../_organisms/SearchRefinementsMembersMyMatches';
import MemberCardRedesign from '@molecules/MemberCardRedesign';
import MemberListItemRedesign from '@molecules/MemberListItemRedesign';

// Functionality
import useMemberMatchFilters from '../../../hooks/algoliaFilters/useMemberMatchFilters';
import { SAVED_CONTACTS_RECORD_ID_QUERY } from '@general/graphql/contact.graph';
import { mapAlgoliaSavedSearchableMemberToProps } from '@general/transforms/member.transform';

const SearchMyMemberMatches = ({
    savedSearch,
    additionalFilters,
    defaultViewType,
    NoResultsText,
    parentView,
    showCalendarIcon = false,
    showSearchBox = true,
    showSearchOptions = true,
    hitsPerPage = 24,
    onCalendarClick,
}) => {
    const { filters, optionalFilters } = useMemberMatchFilters(savedSearch, additionalFilters);

    return (
        <Search
            index="saved_searchable_members"
            defaultViewType={defaultViewType}
            displaySearchBox={showSearchBox}
            displaySearchOptions={showSearchOptions}
            hitsPerPage={hitsPerPage}
            filters={filters}
            optionalFilters={optionalFilters}
            refinementComponent={SearchRefinementsMembersMyMatches}
        >
            <SearchResults
                cardComponent={props => (
                    <MemberCardRedesign
                        {...props}
                        showCalendarIcon={showCalendarIcon}
                        onCalendarClick={onCalendarClick}
                    />
                )}
                listItemComponent={props => (
                    <MemberListItemRedesign
                        {...props}
                        showCalendarIcon={showCalendarIcon}
                        onCalendarClick={onCalendarClick}
                    />
                )}
                index="saved_searchable_members"
                parentView={parentView}
                parentSubview="My Matches"
                query={SAVED_CONTACTS_RECORD_ID_QUERY}
                resultsPerRow={2}
                transformFunc={mapAlgoliaSavedSearchableMemberToProps}
                typePlural="contacts"
                NoResultsText={NoResultsText}
            />
        </Search>
    );
};

SearchMyMemberMatches.propTypes = {
    additionalFilters: PropTypes.string,
    defaultViewType: PropTypes.string,
    parentView: PropTypes.string,
    savedSearch: PropTypes.object.isRequired,
    NoResultsText: PropTypes.elementType,
    showCalendarIcon: PropTypes.bool,
    showSearchBox: PropTypes.bool,
    showSearchOptions: PropTypes.bool,
    hitsPerPage: PropTypes.number,
    onCalendarClick: PropTypes.func,
};

export default SearchMyMemberMatches;
